import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError, setToken, getToken } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = checking, null = anon, obj = user
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    if (!getToken()) { setUser(null); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_) {
      setToken(null);
      setUser(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password, totp) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password, totp });
      if (data.totp_required) return { totp_required: true };
      if (data.access_token) setToken(data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      const msg = formatApiError(e);
      setError(msg);
      return { error: msg };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    setToken(null);
    setUser(null);
  };

  return (
    <Ctx.Provider value={{ user, error, login, logout, refresh }}>
      {children}
    </Ctx.Provider>
  );
}

export function useAuth() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useAuth outside provider");
  return v;
}
